<template>
  <div class="">
  	<!-- header start -->
  	<van-nav-bar 
  	  title="追忆文章" 
  	  right-text="写评论"
  	  left-arrow 
  	  fixed 
  	  :z-index="99" 
  	  @click-left="onClickLeft" 
  	  @click-right="onClickRight"
  	  :border="false"
  	/>
  	<div class="navBarSpace"></div>
  	<!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
      <div v-for="item in dataList" :key="item.SerialNumber">
        <div class="cmt-list">
          <div class="hd">
            <van-image
              round
              width="100%"
              height="100%"
              fit="cover"
              v-bind:src="item.MemberHeadPic"
            />
          </div>
          <div class="bd">
            <div class="user-header">
              <div class="name">{{item.MemberNickName}}</div>
              <p class="date">{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>
              <!-- <van-icon v-if="currentToken && currentToken.memberID == item.MemberId" name="delete" @click="isdel" /> -->
            </div>
            <div class="d-body">
              <!-- {{item.Content}} -->
              <div v-html="item.Content" class="rich"></div>
            </div>
          </div>
        </div>
      </div>
      
      </van-list>

    </van-pull-refresh>
    <!-- <div>
    	<div class="cmt-list" v-for="item in 5" :key="item.id">
    	  <div class="hd">
    	    <van-image
    	      round
    	      width="100%"
    	      height="100%"
    	      fit="cover"
    	      src="https://img.yzcdn.cn/vant/cat.jpeg"
    	    />
    	  </div>
    	  <div class="bd">
    	    <div class="user-header">
    	    	<div class="name">张三</div>
    	    	<p class="date">2020-04-01</p>
    	    	<van-icon name="delete" />
    	    </div>
    	    <div class="d-body">
    	    	紧密围绕在以习近平同志为核心的党中央周围。以实现党的“两个一百年”为奋斗目标。
    	    </div>
    	  </div>
    	</div>
    </div> -->

    <!-- 评论弹出 -->
    <van-popup v-model="isCommentPopup" position="bottom">
      <div class="cmt-popup">
        <van-field
          v-model="commentArea"
          ref="commentArea"
          autofocus
          rows="5"
          type="textarea"
          maxlength="150"
          placeholder="请输入您的评论内容"
          @focus="emotionShow = false"
          @blur="emotionShow = false"
        />
        <div class="btmbar">
          <div class="emojiBtn" @click="emotionShow = !emotionShow"><van-icon name="smile-o" size="32" :color="emotionShow ? '#24a378' : '#444' "/></div>
          <van-button size="small" class="mybtn" @click="addCommandComment">发表</van-button>
        </div>
      </div>
      <div ref="emotionBox">
        <emotion @emotion="handleEmotion" :height="146"  v-if="emotionShow"></emotion>
      </div>
      <!-- <p v-html="commentArea.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></p> -->
    </van-popup>
  </div>
</template>

<script>
  import Emotion from '@/components/Emotion/index'
  import { mapGetters } from "vuex";
  import { Toast } from "vant";
	export default {
	  data() {
	    return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        options: null,
        dataList: [],
	    	isCommentPopup : false,
        emotionShow:false,
        commentArea:''
	    };
    },
    computed: {
      ...mapGetters(["currentToken"])
    },
	  components: {
      Emotion
    },
		methods :{
      onClickLeft() {
			  this.$router.go(-1)
			},
			onClickRight(){
        if (this.currentToken.isLogin){
          this.isCommentPopup = true
        }else{
          Toast("请登录后再进行操作");
        }
			},
      handleEmotion (i) {
        // this.content += i
        this.commentArea += i
      },
      init() {
        var that = this;
        that.options = {
          type: "getCommandCommentList",
          pageIndex: 1,
          memorialArticleID : this.$route.query.memorialArticleID
        };
        that.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1
        });
        this.loading = true;
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1
        });
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            console.log(res);
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }

            var dataList = res.CommandCommentApiExtendList;
            if (dataList.length <= 0) {
              that.finished = true;
            }

            if (dataList.length < 10){
              that.finished = true;
            }

            if (this.options.pageIndex > 1) {
              if (dataList.length > 0) {
                dataList.forEach(element => {
                  that.dataList.push(element);
                });
              }
            } 
            else {
              that.dataList = dataList;
            }
          },
          error => {}
        );
      },
      addCommandComment(){
        var _this = this;
        // console.log(_this.commentArea.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, _this.emotion));
        if (_this.commentArea.trim().length<=0){
          Toast("评论内容不能为空!");
          return;
        }
        
        _this.$store.dispatch({
          type:"addCommandComment",
          "MemorialArticleId" : _this.$route.query.memorialArticleID,
          "Content" : _this.commentArea.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, _this.emotion),
        }).then(res => {
          Toast(res.Message);
          if(res.IsSuccess){
            _this.$router.go(0)
          }
        }).catch(err => {})
      },
      // 将匹配结果替换表情图片
      emotion (res) {
        console.log(res);
        var word = res.replace(/\#|\;/gi,'')
        const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
        var index = list.indexOf(word)
        return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`   
      },
    },
    created(){
      var that = this;
      that.init();
    }
	};
</script>

<style scoped>
.cmt-list{
  display: flex;
  align-items: flex-start;
  margin: 18px;
}
.cmt-list>.hd{
  width: 60px;
  height: 60px;
  margin-right: 10px;
}
.cmt-list>.bd{
	flex: 1;
	overflow: hidden;
}
.cmt-list>.bd>.user-header{
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.cmt-list>.bd>.user-header>.name{
  font-size: 13px;
  color: #777;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
}
.cmt-list>.bd>.user-header>.date{
  font-size: 12px;
  color: #aaa;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 15px;
}
.cmt-list>.bd>.user-header>.van-icon{
  font-size: 21px;
  color: #888;
  margin-left: 12px;
}
.d-body{
  font-size: 15px;
  line-height: 1.5;
  color: #444;
}
.rich>>> img{ max-width: 100%}
</style>
